import React, { useEffect, useState } from "react";
import {
  FaArrowDown,
  FaMapMarkedAlt,
  FaPlus,
  FaShieldAlt,
  FaUsers,
} from "react-icons/fa";

import KataButton from "../ui/KataButton";

const HERO_IMAGES = [
  "/images/fond11.webp",
  "/images/fond12.webp",
  "/images/fond13.webp",
];

export default function KataHero({
  stats,
  statsLoading,
  onCreate,
  onDiscover,
}) {
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setActiveImage(
        (current) => (current + 1) % HERO_IMAGES.length
      );
    }, 7000);

    return () => {
      window.clearInterval(interval);
    };
  }, []);

  return (
    <section className="relative isolate min-h-[680px] overflow-hidden bg-slate-950">
      {HERO_IMAGES.map((image, index) => (
        <div
          key={image}
          className={[
            "absolute inset-0 bg-cover bg-center transition-opacity duration-1000",
            index === activeImage
              ? "opacity-100"
              : "opacity-0",
          ].join(" ")}
          style={{
            backgroundImage: `url("${image}")`,
          }}
        />
      ))}

      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(2,6,23,0.96)_0%,rgba(2,6,23,0.82)_45%,rgba(2,6,23,0.36)_100%)]" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-slate-950/30" />

      <div className="absolute -left-28 top-28 h-72 w-72 rounded-full bg-orange-500/20 blur-3xl" />
      <div className="absolute -right-20 bottom-10 h-80 w-80 rounded-full bg-amber-300/10 blur-3xl" />

      <div className="relative mx-auto flex min-h-[680px] max-w-7xl items-center px-4 py-28 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-amber-300 backdrop-blur-xl">
            <FaMapMarkedAlt />
            Recherche nationale de partenaires
          </div>

          <h1 className="text-5xl font-semibold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-8xl">
            Mon
            <span className="bg-gradient-to-r from-amber-300 via-orange-400 to-red-500 bg-clip-text text-transparent">
              Appli
            </span>
            Kata
          </h1>

          <p className="mt-7 max-w-2xl text-lg leading-relaxed text-slate-200 sm:text-xl">
            Trouvez un Tori ou un Uke pour préparer votre
            prochain passage de grade, organiser vos
            entraînements et progresser ensemble.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <KataButton
              icon={FaPlus}
              size="lg"
              onClick={onCreate}
            >
              Déposer une annonce
            </KataButton>

            <KataButton
              icon={FaArrowDown}
              size="lg"
              variant="secondary"
              onClick={onDiscover}
              className="border-white/15 bg-white/10 text-white hover:bg-white/15 hover:text-white"
            >
              Voir les partenaires
            </KataButton>
          </div>

          <div className="mt-10 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3">
            <HeroStat
              icon={FaUsers}
              value={statsLoading ? "…" : stats.total}
              label="annonces actives"
            />

            <HeroStat
              icon={FaMapMarkedAlt}
              value={statsLoading ? "…" : stats.departements}
              label="départements"
            />

            <HeroStat
              icon={FaShieldAlt}
              value="100 %"
              label="gestion sécurisée"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-slate-50 to-transparent dark:from-slate-950" />
    </section>
  );
}

function HeroStat({ icon: Icon, value, label }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur-xl">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-400 text-slate-950">
          <Icon />
        </span>

        <div>
          <p className="text-xl font-semibold text-white">
            {value}
          </p>
          <p className="text-xs text-slate-300">{label}</p>
        </div>
      </div>
    </div>
  );
}